import { RepeatableState, state as defaultState } from '@/store/modules/repeatable/state';
import { actions } from '@/store/modules/repeatable/actions';
import { mutations } from '@/store/modules/repeatable/mutations';
import { getters } from '@/store/modules/repeatable/getters';
import { Module } from 'vuex';
import { RootState } from '@/store/state';

export default {
  namespaced: true,
  state: defaultState(),
  actions,
  mutations,
  getters
} as Module<RepeatableState, RootState>;
